var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative align-middle"
  }, [_c('h3', {
    staticClass: "mt-10 mb-5 w-full"
  }, [_vm._v("\n    Droits restreints\n  ")]), _vm._v(" "), _c('h6', {
    staticClass: "text-gray-600"
  }, [_vm._v("\n    Vous n’avez pas les droits nécessaires pour accéder à cette page.\n  ")]), _vm._v(" "), _c('h6', {
    staticClass: "text-gray-600"
  }, [_vm._v("\n    Pour les obtenir, vous devez les demander à l’administrateur de votre structure.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-center mt-15"
  }, [_c('illustration', {
    attrs: {
      "name": "notAllowed"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-center mt-15 mb-15"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "Revenir à l'accueil",
      "uppercase": true,
      "icon": "home",
      "type-shadow": "shadow-pink",
      "enable-action": false
    }
  })], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }